import React from 'react'

import * as S from './styled'

const Close = () => {
  return (
    <S.Svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M11.9999 10.5856L5.63592 4.22168L4.22171 5.63589L10.5857 11.9999L4.22168 18.3639L5.63589 19.7781L11.9999 13.4141L18.3638 19.778L19.7781 18.3638L13.4141 11.9999L19.778 5.63594L18.3638 4.22172L11.9999 10.5856Z"/>
    </S.Svg>
  )
}

export default Close
